<button
	mat-button
	[color]="color"
	[ngStyle]="styles"
	[disabled]="disabled"
>
	<ng-content></ng-content>
</button>
